module.exports = __webpack_public_path__ + "img/automatic.png";